import React from "react";
import domAlign from "dom-align";
import { Collapse, Tooltip } from "antd";
import styles from "./style.module.scss";
import { tooltip_labels } from "../../../util/constants";
import { RightOutlined } from "@ant-design/icons";
import CustomChart from "components/Charts";
const { Panel } = Collapse;
const alignConfig = {
  // align top left point of sourceNode with top right point of targetNode
  // the offset sourceNode by 10px in x and 20px in y,
  targetOffset: ["20%", "5%"], // the offset targetNode by 30% of targetNode width in x and 40% of targetNode height in y,
  // auto adjust position when sourceNode is overflowed
};

const alignConfig1 = {
  // align top left point of sourceNode with top right point of targetNode
  // the offset sourceNode by 10px in x and 20px in y,
  targetOffset: ["40%", "0%"], // the offset targetNode by 30% of targetNode width in x and 40% of targetNode height in y,
  // auto adjust position when sourceNode is overflowed
};
const BoardCard = ({
  title,
  selection,
  unselect,
  children,
  extra,
  alwaysOpen,
  id,
  type,
  theme,
}) => {
  return (
    <div className={styles.container} id={id}>
      <Collapse
        collapsible="disabled"
        defaultActiveKey={["key"]}
        bordered={false}
        ghost
        className={`${type ? styles.changeBoardHeader : undefined} ${
          type === "ai-bubble-view" && theme === "light"
            ? styles.lightBoardHeader
            : type === "ai-bubble-view" && theme === "brand"
            ? styles.brandBoardHeader
            : undefined
        }`}
      >
        <Panel
          header={
            selection ? (
              <h5 className={styles.header}>
                <u className={styles.landscapeTitle} onClick={unselect}>
                  {title}
                </u>
                <RightOutlined className={styles.rightIcon} />
                <span className={styles.selection}>{selection}</span>
              </h5>
            ) : (
              title
            )
          }
          key={"key"}
          showArrow={false}
          className={`${styles.content}`}
          extra={<div onClick={(e) => e.stopPropagation()}>{extra}</div>}
          disabled={alwaysOpen}
        >
          {children}
        </Panel>
      </Collapse>
    </div>
  );
};

export default BoardCard;

// New AppRatingCard component for custom app rating design
export const AppRatingCard = ({ data, theme,reviewsAvgRating }) => {  
  const d = data;
  // Color settings for theme
  const fontColor = theme === "dark" ? "#fff": "#100d31" ;
  const starColor = "gold";
  const countColor = fontColor;
  const ratingColor = theme === "dark" ? "#fff" : "#100d31";
  const barBgColor = theme === "dark" ? "#18162b" : "#fff";
  const options = {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        display: false,
        color: "transparent",
      },
      tooltip: {
        enabled: false,
      },
    },
    scales: {
      x: {
        display: false,
        beginAtZero: true 
      },
      y: {
        display: false,
        beginAtZero: true 
      },
    },
    elements: {
      point: {
        radius: 0,
      },
    },
    layout: {
      padding: {
        top: 5,
      },
    },
  };
  // For breakdown stars and stacked bar chart, use red for 1-2, yellow for 3, green for 4-5
  const getRatingColor = (star) => {
    if (star <= 2) return '#FF4D4F'; // red
    if (star === 3) return '#FFD700'; // yellow
    return '#52C41A'; // green
  };
  return (
    <div className={styles.appRatingCard}>
      <div className={styles.ratingRow}>
        <span className={styles.rating} style={{ color: ratingColor }}>{d.rating}</span>
        <span className={styles.stars}>
          {[...Array(5)].map((_, i) => (
            <span key={i} style={{ color: starColor, fontSize: 24 }}>★</span>
          ))}
        </span>
        <span className={styles.reviews}>{reviewsAvgRating} Reviews Only</span>
      </div>
      <div className={styles.mainContentRow}>
        <div className={styles.breakdownSection}>
          <div className={styles.breakdownHeader}>Breakdown</div>
          <div className={styles.breakdownList}>
            {d.breakdown.map((item, idx) => (
              <div className={styles.breakdownItem} key={item.stars}>
                <span className={styles.starsLabel} style={{ color: getRatingColor(item.stars) }}>{item.stars}★</span>
                <span className={styles.count} style={{ color: countColor }}>{item.count}</span>
                <span className={styles.barBg} style={{ background: barBgColor }}>
                  <span
                    className={styles.barFill}
                    style={{ width: `${item.percent}%`, background: getRatingColor(item.stars) }}
                  ></span>
                </span>
              </div>
            ))}
          </div>
        </div>
        <div className={styles.dailySection}>
          <div className={styles.dailyHeader}>Daily</div>
          <div className={styles.dailyChart} style={{ height: 160, minHeight: 120, maxHeight: 180 }}>
            {/* Stacked Bar Chart for Daily Star Counts */}
            {d.daily_star_counts && d.daily_star_counts.length > 0 ? (
              (() => {
                const dailyStarCounts = d.daily_star_counts;
                const labels = dailyStarCounts.map(entry => entry.date);
                const starColors = [getRatingColor(1), getRatingColor(2), getRatingColor(3), getRatingColor(4), getRatingColor(5)];
                const datasets = [1,2,3,4,5].map(star => ({
                  label: `${star}★`,
                  data: dailyStarCounts.map(entry => entry[String(star)] || 0),
                  backgroundColor: starColors[star-1],
                  stack: 'stars',
                  borderRadius: 8,
                  barPercentage: 0.7,
                  categoryPercentage: 0.7
                }));
                const stackedBarOptions = {
                  ...options,
                  plugins: {
                    ...options.plugins,
                    legend: {
                      display: false
                    },
                    tooltip: {
                      enabled: true,
                      backgroundColor: theme === "dark" ? "#23213a" : "#fff",
                      titleColor: fontColor,
                      bodyColor: fontColor,
                      borderColor: theme === "dark" ? "#444" : "#ddd",
                      borderWidth: 1,
                      callbacks: {
                        label: function(context) {
                          const star = context.dataset.label;
                          const value = context.parsed.y;
                          return `${star}: ${value} ratings`;
                        }
                      }
                    }
                  },
                  scales: {
                    x: {
                      stacked: true,
                      grid: { display: false },
                      title: { display: false },
                      ticks: {
                        display: false
                      }
                    },
                    y: {
                      stacked: true,
                      beginAtZero: true,
                      grid: { display: false },
                      title: { display: false },
                      ticks: { color: fontColor, font: { size: 10 } }
                    }
                  },
                  elements: {
                    bar: {
                      borderRadius: 8,
                      borderSkipped: false,
                      barThickness: 12
                    }
                  },
                  layout: {
                    padding: { left: 0, right: 0, top: 0, bottom: 10 }
                  },
                  maintainAspectRatio: false,
                  responsive: true,
                  aspectRatio: 2.5
                };
                return (
                  <CustomChart
                    type="bar"
                    data={{ labels, datasets }}
                    options={stackedBarOptions}
                    theme={theme}
                    height={140}
                  />
                );
              })()
            ) : (
              <div>No daily star data available</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
